import React, { useState } from 'react';
import { UserRound } from 'lucide-react';
import { getChatPortrait } from '../services/ChatPortraitService';

export function ReadingSpeechAvatar({ name }) {
  const src = getChatPortrait(name);
  const [failedSource, setFailedSource] = useState(null);
  return (
    <span className="reading-speech-avatar" role="img" aria-label={name} title={name}>
      {src && failedSource !== src
        ? <img src={src} alt="" onError={() => setFailedSource(src)} />
        : <UserRound size={24} strokeWidth={1.8} aria-hidden="true" />}
    </span>
  );
}

export default function ReadingSpeechBubble({ name, speaker, children, onClick, showAvatar = true }) {
  return (
    <div className={`reading-speech-with-avatar speaker-${speaker.toLowerCase()}${showAvatar ? '' : ' without-avatar'}`}>
      {showAvatar && <ReadingSpeechAvatar name={name} />}
      <div className="reading-practice-speech-bubble" onClick={onClick}>{children}</div>
    </div>
  );
}
